/*
  BDEK collection page (sections/bdek-main-collection.liquid)
  - Desktop: changing a filter or the sort applies it right away.
  - Phones: filters open in a full-screen drawer; "Show results" applies them.
  - "Load more" fetches the next page and appends its products (plain link without JS).
*/
(function () {
  var desktop = window.matchMedia('(min-width: 990px)');

  function init(root) {
    if (root.dataset.bdekCollectionReady) return;
    root.dataset.bdekCollectionReady = 'true';

    var form = root.querySelector('[data-bdek-filter-form]');
    var drawer = root.querySelector('[data-bdek-filter-drawer]');
    var openBtn = root.querySelector('[data-bdek-filter-open]');
    var closeBtn = root.querySelector('[data-bdek-filter-close]');

    function submitForm() {
      if (!form) return;
      // Drop empty price fields so the URL stays clean
      form.querySelectorAll('input[type="number"]').forEach(function (input) {
        input.disabled = input.value === '';
      });
      form.submit();
    }

    // Instant apply on desktop (sidebar), and always for the sort menu
    root.addEventListener('change', function (event) {
      var target = event.target;
      if (target.matches('[data-bdek-autosubmit]')) {
        submitForm();
        return;
      }
      if (form && form.contains(target) && desktop.matches && target.type !== 'number') {
        submitForm();
      }
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        submitForm();
      });
    }

    // Drawer (phones)
    function openDrawer() {
      root.classList.add('is-filtering');
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      document.documentElement.classList.add('bdek-no-scroll');
      openBtn.setAttribute('aria-expanded', 'true');
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      root.classList.remove('is-filtering');
      drawer.removeAttribute('role');
      drawer.removeAttribute('aria-modal');
      document.documentElement.classList.remove('bdek-no-scroll');
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    }

    if (openBtn && drawer) {
      openBtn.addEventListener('click', openDrawer);
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      drawer.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && root.classList.contains('is-filtering')) closeDrawer();
        if (event.key !== 'Tab' || !root.classList.contains('is-filtering')) return;
        var focusable = drawer.querySelectorAll('button, input:not([disabled]), select, a[href]');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    // Load more
    root.addEventListener('click', function (event) {
      var more = event.target.closest('[data-bdek-load-more]');
      if (!more || !window.fetch) return;
      event.preventDefault();
      more.setAttribute('aria-busy', 'true');
      more.classList.add('is-loading');

      fetch(more.href, { headers: { Accept: 'text/html' } })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = root.querySelector('[data-bdek-grid]');
          var newItems = doc.querySelectorAll('[data-bdek-grid] [data-bdek-item]');
          var firstNew = null;
          newItems.forEach(function (item) {
            var imported = document.importNode(item, true);
            if (!firstNew) firstNew = imported;
            grid.appendChild(imported);
          });

          var showing = root.querySelector('[data-bdek-showing]');
          if (showing) {
            var shown = grid.querySelectorAll('[data-bdek-item]').length;
            var template = showing.getAttribute('data-template') || 'Showing [shown] of [total]';
            showing.textContent = template.replace('[shown]', shown).replace('[total]', showing.getAttribute('data-total'));
          }

          var nextMore = doc.querySelector('[data-bdek-load-more]');
          if (nextMore) {
            more.href = nextMore.getAttribute('href');
            more.removeAttribute('aria-busy');
            more.classList.remove('is-loading');
          } else {
            more.remove();
          }

          // Move focus to the first new product so keyboard users continue from there
          var focusTarget = firstNew && firstNew.querySelector('.bdek-card__title a');
          if (focusTarget) focusTarget.focus({ preventScroll: true });
        })
        .catch(function () {
          window.location.href = more.href;
        });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bdek-collection]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
